
 <mat-card class="my-card">
   <form [formGroup]="registrationForm" class="my-form">
    <mat-card-content>
        
                <mat-form-field appearance="outline" class="full-width">
                   <mat-label>Contact Person/Full Name</mat-label>
                  <input type="text" matInput placeholder="Contact Person" id="contactPerson" formControlName="contactPerson" class="form-control" required>
                  <mat-error *ngIf="contactPerson.invalid && (contactPerson.dirty || contactPerson.touched)">
                     {{getEmailErrorMessage()}}
                  </mat-error>
                </mat-form-field>
                <!-- <mat-form-field class="full-width">
                   <mat-label>Last Name</mat-label>
                   <input  matInput  placeholder="Last Name" name="lname"  required>
                </mat-form-field> -->
                <mat-form-field appearance="outline" class="full-width">
                   <mat-label>Client Organization</mat-label>
                  <input type="text" matInput placeholder="Client Organization" id="clientOrganization" formControlName="clientOrganization" class="form-control"
                     required>
                  <mat-error *ngIf="clientOrganization.invalid && (clientOrganization.dirty || clientOrganization.touched)">
                     {{getEmailErrorMessage()}}
                  </mat-error>
                </mat-form-field>
               <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Branch</mat-label>
                  <input type="text" matInput placeholder="Branch" id="branch" formControlName="branch"
                     class="form-control" >
               </mat-form-field>
                <mat-form-field appearance="outline" class="full-width">
                   <mat-label>Email</mat-label>
                  <input matInput placeholder="Email" id="userEmail" formControlName="userEmail" class="form-control" required>
                  <mat-error *ngIf="userEmail.invalid && (userEmail.dirty || userEmail.touched)">
                     {{getEmailErrorMessage()}}
                  </mat-error>
                </mat-form-field>
               <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Password</mat-label>
                  <input matInput type="password" placeholder="Password" id="userPassword" formControlName="userPassword" class="form-control" required>
                  <mat-error *ngIf="userPassword.invalid && (userPassword.dirty || userPassword.touched)">
                     {{getPasswordErrorMessage()}}
                  </mat-error>
               </mat-form-field>
                <section class="full-width">
                    <mat-label >Gender: </mat-label>
                    <mat-radio-group placeholder="Gender" id="gender" formControlName="gender" class="form-control" >
                      <mat-radio-button style="margin: 0 0.2rem;" value="Male">Male </mat-radio-button>
                      <mat-radio-button style="margin: 0 0.2rem;" value="Female">Female </mat-radio-button>
                      <mat-radio-button style="margin: 0 0.2rem;" value="Other">Other </mat-radio-button>
                    </mat-radio-group>
                  </section>
               
                  <!-- <mat-form-field class="full-width">
                    <mat-label>Date of Registration</mat-label>
                <input matInput [matDatepicker]="picker" placeholder="Date of Registration">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field> -->
         <!-- <div *ngIf="dialog"><dialog-overview-example [message]="message"></dialog-overview-example></div> -->
    </mat-card-content>
    <mat-card-actions style="padding: 1rem;">
        <button [disabled]="!registrationForm.valid" mat-raised-button (click)="register()" color="primary" type="submit">REGISTER</button>
      <button mat-raised-button (click)="clear()" color="warn">CANCEL</button>
    </mat-card-actions>
   </form>

   
 </mat-card>



<!-- <app-progress-spinner overlay="true">
</app-progress-spinner> -->